import React from 'react';
import Text from '../../../atoms/Text';
import { IRow } from './TableCard';

interface ITableRowItemMobileProps extends IRow {
  opened?: boolean;
  open?: boolean;
  index: number;
}

const TableRowItemMobile = ({
  name,
  content,
  width,
  opened,
  open,
  index,
  handleClick,
}: ITableRowItemMobileProps) => {
  const colorStyle =
    content.color === 'grey'
      ? `text--${content.color}-400`
      : `text--${content.color}-600`;

  const isElement = React.isValidElement(content.value) && !content.string;

  return (
    <div
      style={{ width, minWidth: width, height: open ? 40 : undefined }}
      className='table_mobile__card__content__row__item'
    >
      <div
        className={`table_mobile__card__content__row__item__text${
          !!opened && !name
            ? ' table_mobile__card__content__row__item__text--center'
            : ''
        }${
          !!opened && index % 2 !== 0
            ? ' table_mobile__card__content__row__item__text--right'
            : ''
        }`}
      >
        {name && !!open && (
          <Text
            size={12}
            className='table_mobile__card__content__row__item__text__header'
          >
            {name}
          </Text>
        )}
        {isElement ? (
          content.value
        ) : (
          <Text
            size={14}
            onClick={handleClick}
            className={`table_mobile__card__content__row__item__text__value ${colorStyle}`}
          >
            {content.value}
          </Text>
        )}
      </div>
    </div>
  );
};

export default TableRowItemMobile;
